/**
 * 비개발자·운영자·구매 담당용 평문 카피 (단일 소스).
 * 기준: docs/UX_WRITING_MASTER.md · ChatGPT Pro PARKWAVE UX 라이팅 개정안
 */

export const PLAIN = {
  brand: {
    /** 최상위 정의 — 한 문장 */
    definition:
      'CCTV·센서·현장 장비의 신호를 상황 판단, 대응 확인, 현장 조치와 증거 기록으로 연결하는 공간 운영 AI 플랫폼입니다.',
    oneLiner: '기존 CCTV를, 판단하고 실행하는 운영 시스템으로.',
    heroLead:
      '감지된 상황을 우선순위로 정리하고, 담당자가 근거를 확인한 뒤 조치·기록까지 이어 갑니다. 카메라는 그대로 둡니다.',
    trustNote: '영상은 현장에 두고, 위로는 짧은 알림·메타만 올리는 구성을 권장합니다.',
    positioning:
      '녹화·재생 중심의 관제나 “사람·차 있음”만 알려 주는 범용 AI와 달리, 확인이 필요한 장면을 선별하고 대응까지 연결합니다.',
    differentiator:
      '기존 CCTV·관제를 교체하지 않습니다. 주차·건물·보안·공장에 맞는 알림 말투와 연결 방식을 미리 맞춰 둡니다.',
    label: 'PARKWAVE · 공간 운영 AI 플랫폼',
    short: '공간을 보고, 판단하고, 움직이게 하는 운영 AI',
  },
  terms: {
    event: '이벤트',
    eventHint: '카메라·장치가 감지한 개별 신호입니다.',
    situation: '상황',
    situationHint: '관련 이벤트를 묶어 담당자가 확인하고 조치하는 업무 단위입니다.',
    alert: '알림',
    alertHint: '이벤트나 상황의 변화를 사용자에게 전달하는 메시지입니다.',
    confidence: '감지 신뢰도',
    confidenceHint: 'AI가 해당 유형으로 분류한 상대적 확신입니다. 실제 위험 확률을 의미하지 않습니다.',
    severity: '위험 수준',
    severityHint: '운영 정책·시간·위치를 기준으로 정한 처리 우선순위입니다.',
    zone: '분석 구역',
    zoneHint: '영상 안에서 AI가 집중적으로 확인하는 영역입니다.',
  },
  audience: {
    operator: '운영·관제 담당',
    buyer: '도입·구매 담당',
    it: 'IT·SI 담당',
  },
  try: {
    title: '샘플 영상으로 분석 테스트',
    lead:
      '로그인 없이 사진·짧은 영상을 올려 보세요. 「우리 현장」에 맞는 알림 말투도 바로 바꿔 볼 수 있습니다.',
    steps: [
      { title: '현장 유형 고르기', desc: '주차·건물·공장·보안 중 가까운 것을 고릅니다.' },
      { title: '파일 올리기', desc: '사진 또는 짧은 영상을 끌어다 놓거나 선택합니다.' },
      { title: '결과·알림 예시 보기', desc: '인식 결과와, 실제로 받을 알림 예시를 함께 봅니다.' },
    ],
    productLineHint: '버튼만 바꾸면 「알림 말투」가 바뀝니다. 분석 방식은 같습니다.',
    notProduction:
      '공개 체험은 이해를 돕기 위한 예시입니다. 현장 장비의 속도·정확도와 같다고 보시면 안 됩니다.',
    capabilitiesOk: '체험용 분석이 준비되어 있습니다. 지금 올리면 결과를 볼 수 있습니다.',
    capabilitiesDemo:
      '간단(데모) 모드일 수 있습니다. 그래도 업로드와 알림 형식 체험은 가능합니다.',
    capabilitiesFail:
      '분석 서버에 연결되지 않습니다. 잠시 후 다시 시도하거나 IT 담당에게 서버 연결을 문의해 주세요.',
    capabilitiesTechToggle: '기술 세부 (개발·IT용)',
  },
  login: {
    title: 'PARKWAVE 운영 콘솔',
    lead: '등록된 계정으로 로그인하세요.',
    demoLead: '데모 계정으로 운영 현황과 여러 출처 화면을 먼저 둘러보세요.',
    demoNote: '실제 서비스에 쓰기 전에는 반드시 비밀번호를 바꿉니다.',
    failHint: '로그인이 안 되면 운영 서버가 켜져 있는지 IT 담당에게 확인해 주세요.',
    apiOnline: '운영 서버와 연결되어 있습니다',
    apiOffline: '운영 서버에 연결할 수 없습니다. 주소·배포 상태를 확인해 주세요.',
    beforeLogin: '처음이신가요? 먼저 「샘플 영상으로 분석 테스트」에서 알림 형식을 보는 것을 권장합니다.',
    submit: '로그인',
  },
  console: {
    dashboard: '운영 현황',
    dashboardDesc: '현장의 이벤트, 승인·검토 대기와 장치·서버 상태를 한눈에 확인합니다.',
    fusion: '여러 출처 한곳에',
    fusionDesc: '카메라·레이더·현장 장비에서 온 신호를 한 목록으로 보고 선택해 확인합니다.',
    training: 'AI 학습',
    startGuide: '시작하기',
    welcome:
      '오늘 확인이 필요한 이벤트와 검토 피드백을 한 화면에서 봅니다. 표에서 ↑↓로 고르고 Enter로 확정할 수 있습니다.',
    fusionWelcome:
      '여러 곳에서 온 이벤트를 한 줄로 봅니다. 「데모 추가」·「현장 시뮬」로 샘플을 넣을 수 있습니다.',
    eventsAutoRefresh: '3초마다 자동으로 업데이트됩니다',
    eventsEmpty:
      '아직 이벤트가 없습니다. 「여러 출처 한곳에」에서 데모 추가 또는 현장 시뮬을 눌러 보세요.',
    onboardingBanner:
      '처음이신가요? 시작하기에서 체험 → 운영 현황 → 연결 체크리스트까지 순서대로 안내합니다.',
    feedbackTitle: '탐지 결과 검토',
    eventsTitle: '최근 이벤트',
    eventsHelp: '이벤트는 AI와 장치가 감지한 개별 신호입니다. 관련 신호는 하나의 상황으로 묶을 수 있습니다.',
    sampleEvent: '샘플 이벤트 넣기',
    demoIngest: '데모 추가',
    edgeSim: '현장 시뮬',
    refresh: '새로고침',
    headerProduct: '운영 콘솔',
    logout: '로그아웃',
    loginLink: '로그인',
    skipToContent: '본문으로 건너뛰기',
    userFallback: '사용자',
    userHonorific: '님',
    menuAria: '앱 주 메뉴',
    mainAria: '앱 본문',
    timelineEmpty: '표시할 이벤트가 없습니다. 기간·위험 수준 필터를 넓혀 보거나 샘플 이벤트를 넣어 보세요.',
    secondLook: '2차 확인',
    episode: '에피소드',
  },
  onboarding: {
    title: '시작하기',
    lead: '현장과 알림 형식을 확인하고, 운영 화면까지 이어 갑니다.',
    dismiss: '다시 보지 않기',
    openGuide: '가이드 열기',
  },
  integration: {
    title: '이미 쓰는 시스템과 연결하기',
    lead:
      '관제·보안·티켓·센서는 같은 「짧은 알림」 형식으로 붙입니다. 코드보다 먼저, 받을 항목 이름을 맞추는 것이 중요합니다.',
    ctaDocs: '연결 방법 보기',
  },
  marketing: {
    ctaTry: '샘플 영상으로 분석 테스트',
    ctaDocs: '제품이 작동하는 방식 보기',
    ctaLogin: '제품 로그인',
    ctaAppHub: '우리 현장 적용 가능성 확인',
    ctaPoc: 'PoC 범위 확인',
    navParking: '주차',
    navBuilding: '건물',
    navSecurity: '보안',
    navFactory: '공장',
    navReports: '산업 리포트',
    navExplore: '제품 둘러보기',
    externalPortal: '외부 포털',
    sitePark: '주차·빌딩',
    siteParkHint: '점유·체류·혼잡을 운영 지표로',
    siteParkDetail:
      '주차면 점유, 차량 이동, 체류와 혼잡도를 분석해 운영에 필요한 알림과 지표로 제공합니다.',
    siteAm: '건물·시설',
    siteAmHint: '로비·외곽을 같은 알림 형식으로',
    siteAmDetail: '출입·건물 관리와 한 줄로 이어, 확인이 필요한 장면만 운영·보안 담당자에게 전달합니다.',
    siteArms: '공공·보안 관제',
    siteArmsHint: '경계·침입 가능성을 상황으로',
    siteArmsDetail: '기존 관제는 유지하고, 근거가 남는 짧은 알림으로 확인·대응을 이어 갑니다.',
    siteInfra: '공장·물류',
    siteInfraHint: '동선·체류를 현장 운영에',
    siteInfraDetail: '작업 구역 체류와 이상 동선을 운영 알림으로 바꿔, 기존 설비 관제와 함께 봅니다.',
    valueTitle: '무엇을 하나요?',
    valueBody:
      'CCTV에서 확인이 필요한 장면을 선별하고, 운영자가 읽을 수 있는 이벤트·상황으로 만듭니다. 카메라는 그대로 둡니다.',
    problemTitle: '카메라는 늘었지만, 판단과 대응은 여전히 사람이 이어 붙입니다.',
    problemBody:
      '기존 관제는 영상을 저장·보여주는 데 집중합니다. 이상 상황이 생기면 담당자가 여러 화면을 보고, 위험도를 판단하고, 연락하고, 보고서를 직접 써야 합니다. 파크웨이브는 감지 이후의 과정을 하나의 운영 흐름으로 연결합니다.',
    flowTitle: '감지부터 판단·확인과 증거까지, 하나의 운영 흐름',
    vsTitle: '다른 방식과 무엇이 다른가요?',
    securityTitle: '영상과 운영 데이터의 민감도에 맞춰 배포합니다',
    securityLead:
      '현장 환경에 따라 클라우드·엣지·고객 망 내 배포를 선택할 수 있습니다. 영상은 현장에 두고 알림만 올리는 구성을 권합니다.',
    trustStrip: '기존 CCTV·관제 활용 · 클라우드·엣지·온프레미스 · 제한된 현장부터 단계 도입',
  },
  honesty: {
    kicker: '과장 없는 현재 상태',
    techTitle: '기술',
    techBody:
      '엣지 파이프라인(감지·ROI 체류·HMAC·업링크)은 코드로 준비되어 있습니다. 클라우드 공개 체험은 데모이며, 현장 GPU/NPU와 같다고 보시면 안 됩니다.',
    useTitle: '실사용',
    useBody:
      '파일럿 1곳 코드는 준비되어 있습니다. 남은 핵심은 현장 카메라 부착과 운영 시크릿입니다. 멀티사이트 SaaS·OAuth는 아직 없습니다.',
    salesTitle: '세일즈',
    salesBody:
      '교체 없는 기존 CCTV와 상황 단위 운영이 차별점입니다. Genetec·Verkada급 완성형 관제나 카메라 교체형 클라우드로 포장하면 안 됩니다.',
  },
  diagram: {
    conceptAria: '이벤트, 상황, 알림의 관계',
    join: '묶기',
    deliver: '전달',
    eventEx1: '사람 감지',
    eventEx2: '구역 진입',
    eventEx3: '연결 끊김',
    sitEx1: '북측 펜스 침입 의심',
    sitEx2: '담당자 확인·조치',
    alertEx1: '앱·문자·메일',
    alertEx2: '웹훅·티켓',
    mockAria: '예시 운영 화면',
    mockLabel: '예시 운영 화면',
    mockTitle: '북측 펜스 움직임 감지',
    mockBody: '동일 객체가 2대 카메라에서 연속 확인되었습니다.',
    mockUrgent: '즉시 대응',
    mockAgo: '42초 전',
    mockRec: '권장 확인',
    mockRecBody: '열화상 또는 인접 카메라로 외곽을 추가로 확인하세요.',
    mockEvidence: '판단 근거 보기',
    mockProcess: '대응 과정 보기',
    flowDetect: '감지',
    flowJudge: '판단',
    flowConfirm: '확인',
    flowAct: '조치',
    flowRecord: '기록',
    compareAria: '기존 방식과 파크웨이브 비교',
    compareBefore: '기존 방식',
    compareAfter: 'PARKWAVE',
    before1: '영상 화면을 사람이 계속 확인',
    before2: '알림이 낱개로 반복',
    before3: '전화·메신저로 승인 연결',
    before4: '보고서 수작업',
    after1: '확인이 필요한 상황만 우선 표시',
    after2: '관련 이벤트를 상황으로 묶음',
    after3: '근거 확인 후 화면에서 조치',
    after4: '영상·판단·조치 기록 자동 정리',
    deployAria: '배포 방식',
    deployEdge: '현장 엣지',
    deployEdgeD: '영상은 현장에서 분석',
    deployCloud: '클라우드',
    deployCloudD: '요약·리포트·연동',
    deployOnprem: '온프레미스',
    deployOnpremD: '고객 망 내부 운영',
    deployAirgap: '망분리',
    deployAirgapD: '보안 요건에 맞춤',
  },
  chrome: {
    wordmark: '파크웨이브',
    wordmarkLatin: 'Parkwave',
    titleSuffix: '파크웨이브',
    documentTitle: '파크웨이브 | 기존 CCTV를, 판단하고 실행하는 운영 시스템으로',
    metaDescription:
      '파크웨이브 | 기존 CCTV를 공간 운영 AI로. CCTV·센서·현장 장비의 신호를 감지, 우선순위 분류, 조치 확인, 증거와 리포트로 연결합니다.',
    homeAria: '파크웨이브 홈',
    langAria: '언어',
    langKo: '한국어',
    langEn: 'English',
  },
  health: {
    apiOffline: 'API 오프라인',
    apiOfflineAria: 'API 연결 실패',
    stream: '스트림',
    demo: '(데모)',
  },
  buttons: {
    confirmSituation: '상황 확인',
    save: '저장',
    closeWithoutChange: '변경하지 않고 닫기',
    retryVideo: '영상을 다시 불러오기',
    notifyAssignee: '담당자에게 알림',
  },
  empty: {
    events: '조건에 맞는 이벤트가 없습니다. 조회 기간이나 위험 수준을 넓혀 보세요.',
    generic: '표시할 항목이 없습니다.',
  },
};

/** 운영 흐름 6단계 — 랜딩·온보딩 공통 */
export const OPERATING_FLOW = [
  { title: '현장 신호 수집', desc: '기존 CCTV·센서·현장 장비의 데이터를 연결합니다.' },
  { title: '이벤트 감지', desc: '사람·차량·구역 진입·이상 상태를 운영 이벤트로 변환합니다.' },
  { title: '상황 판단', desc: '관련 이벤트를 묶고 위험 수준과 처리 우선순위를 분류합니다.' },
  { title: '대응 안내', desc: '운영 정책과 현장 상태를 바탕으로 다음에 할 일을 제시합니다.' },
  { title: '확인·조치', desc: '담당자가 근거를 확인하고 조치·연동을 진행합니다.' },
  { title: '증거·개선', desc: '영상·판단·조치 결과를 남기고 이후 운영에 반영합니다.' },
];

export type PlainCopy = typeof PLAIN;
export type OperatingFlow = typeof OPERATING_FLOW;
